module.exports = __webpack_public_path__ + "img/case53.05155464.png";